// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file proyectos.proto (package sextante.proyectos.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file proyectos.proto.
 */
export const file_proyectos: GenFile = /*@__PURE__*/
  fileDesc("Cg9wcm95ZWN0b3MucHJvdG8SFXNleHRhbnRlLnByb3llY3Rvcy52MSIYChZHZXRNaXNQcm95ZWN0b3NSZXF1ZXN0IkwKFE1pc1Byb3llY3Rvc1Jlc3BvbnNlEjQKBWl0ZW1zGAEgAygLMiUuc2V4dGFudGUucHJveWVjdG9zLnYxLk1pUHJveWVjdG9JdGVtIvYBCg5NaVByb3llY3RvSXRlbRIKCgJpZBgBIAEoCRIOCgZub21icmUYAiABKAkSFAoMZmluY2Ffbm9tYnJlGAMgASgJEhEKCW11bmljaXBpbxgEIAEoCRIWCg5jdWx0aXZvX25vbWJyZRgFIAEoCRIQCgh2YXJpZWRhZBgGIAEoCRIKCgJoYRgHIAEoARIUCgxmZWNoYV9pbmljaW8YCCABKAkSDgoGZXN0YWRvGAkgASgJEhUKDWl0ZW1zX2FjdGl2b3MYCiABKAUSGQoRcHJlc3VwdWVzdG9fdG90YWwYCyABKAMSEQoJZWplY3V0YWRvGAwgASgDIjIKG0dldE1pUHJveWVjdG9EZXRhbGxlUmVxdWVzdBITCgtwcm95ZWN0b19pZBgBIAEoCSLcAQoZTWlQcm95ZWN0b0RldGFsbGVSZXNwb25zZRI3Cghwcm95ZWN0bxgBIAEoCzIlLnNleHRhbnRlLnByb3llY3Rvcy52MS5NaVByb3llY3RvSXRlbRIQCghzZW1hZm9ybxgCIAEoCRI7CghkZXNnbG9zZRgDIAMoCzIpLnNleHRhbnRlLnByb3llY3Rvcy52MS5NaVByb3llY3RvRGVzZ2xvc2USNwoHbGFib3JlcxgEIAMoCzImLnNleHRhbnRlLnByb3llY3Rvcy52MS5NaVByb3llY3RvTGFib3IiTAoSTWlQcm95ZWN0b0Rlc2dsb3NlEgwKBHRpcG8YASABKAkSFQoNcHJlc3VwdWVzdGFkbxgCIAEoAxIRCgllamVjdXRhZG8YAyABKAMiTAoPTWlQcm95ZWN0b0xhYm9yEgwKBHRpcG8YASABKAkSCwoDc3ViGAIgASgJEg4KBm5vbWJyZRgDIAEoCRIOCgZlc3RhZG8YBCABKAkyhgIKF1Byb3llY3Rvc0NsaWVudGVTZXJ2aWNlEm0KD0dldE1pc1Byb3llY3RvcxItLnNleHRhbnRlLnByb3llY3Rvcy52MS5HZXRNaXNQcm95ZWN0b3NSZXF1ZXN0Gisuc2V4dGFudGUucHJveWVjdG9zLnYxLk1pc1Byb3llY3Rvc1Jlc3BvbnNlEnwKFEdldE1pUHJveWVjdG9EZXRhbGxlEjIuc2V4dGFudGUucHJveWVjdG9zLnYxLkdldE1pUHJveWVjdG9EZXRhbGxlUmVxdWVzdBowLnNleHRhbnRlLnByb3llY3Rvcy52MS5NaVByb3llY3RvRGV0YWxsZVJlc3BvbnNlQguqAghBcGkuR3JwY2IGcHJvdG8z");

/**
 * Sin parametros: el cliente sale de la sesion.
 *
 * @generated from message sextante.proyectos.v1.GetMisProyectosRequest
 */
export type GetMisProyectosRequest = Message<"sextante.proyectos.v1.GetMisProyectosRequest"> & {
};

/**
 * Describes the message sextante.proyectos.v1.GetMisProyectosRequest.
 * Use `create(GetMisProyectosRequestSchema)` to create a new message.
 */
export const GetMisProyectosRequestSchema: GenMessage<GetMisProyectosRequest> = /*@__PURE__*/
  messageDesc(file_proyectos, 0);

/**
 * Proyectos no eliminados del agricultor.
 *
 * @generated from message sextante.proyectos.v1.MisProyectosResponse
 */
export type MisProyectosResponse = Message<"sextante.proyectos.v1.MisProyectosResponse"> & {
  /**
   * @generated from field: repeated sextante.proyectos.v1.MiProyectoItem items = 1;
   */
  items: MiProyectoItem[];
};

/**
 * Describes the message sextante.proyectos.v1.MisProyectosResponse.
 * Use `create(MisProyectosResponseSchema)` to create a new message.
 */
export const MisProyectosResponseSchema: GenMessage<MisProyectosResponse> = /*@__PURE__*/
  messageDesc(file_proyectos, 1);

/**
 * Resumen para el selector + la cabecera del proyecto.
 *
 * @generated from message sextante.proyectos.v1.MiProyectoItem
 */
export type MiProyectoItem = Message<"sextante.proyectos.v1.MiProyectoItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * nombre del proyecto
   *
   * @generated from field: string nombre = 2;
   */
  nombre: string;

  /**
   * vacio si el proyecto no tiene finca asociada
   *
   * @generated from field: string finca_nombre = 3;
   */
  fincaNombre: string;

  /**
   * @generated from field: string municipio = 4;
   */
  municipio: string;

  /**
   * @generated from field: string cultivo_nombre = 5;
   */
  cultivoNombre: string;

  /**
   * @generated from field: string variedad = 6;
   */
  variedad: string;

  /**
   * @generated from field: double ha = 7;
   */
  ha: number;

  /**
   * ISO 8601; vacio si no tiene
   *
   * @generated from field: string fecha_inicio = 8;
   */
  fechaInicio: string;

  /**
   * borrador | en_revision | aprobado | activo | cerrado | suspendido
   *
   * @generated from field: string estado = 9;
   */
  estado: string;

  /**
   * @generated from field: int32 items_activos = 10;
   */
  itemsActivos: number;

  /**
   * COP
   *
   * @generated from field: int64 presupuesto_total = 11;
   */
  presupuestoTotal: bigint;

  /**
   * COP
   *
   * @generated from field: int64 ejecutado = 12;
   */
  ejecutado: bigint;
};

/**
 * Describes the message sextante.proyectos.v1.MiProyectoItem.
 * Use `create(MiProyectoItemSchema)` to create a new message.
 */
export const MiProyectoItemSchema: GenMessage<MiProyectoItem> = /*@__PURE__*/
  messageDesc(file_proyectos, 2);

/**
 * Proyecto del que se pide el detalle.
 *
 * @generated from message sextante.proyectos.v1.GetMiProyectoDetalleRequest
 */
export type GetMiProyectoDetalleRequest = Message<"sextante.proyectos.v1.GetMiProyectoDetalleRequest"> & {
  /**
   * @generated from field: string proyecto_id = 1;
   */
  proyectoId: string;
};

/**
 * Describes the message sextante.proyectos.v1.GetMiProyectoDetalleRequest.
 * Use `create(GetMiProyectoDetalleRequestSchema)` to create a new message.
 */
export const GetMiProyectoDetalleRequestSchema: GenMessage<GetMiProyectoDetalleRequest> = /*@__PURE__*/
  messageDesc(file_proyectos, 3);

/**
 * Detalle de un proyecto del agricultor: estado financiero y labores.
 *
 * @generated from message sextante.proyectos.v1.MiProyectoDetalleResponse
 */
export type MiProyectoDetalleResponse = Message<"sextante.proyectos.v1.MiProyectoDetalleResponse"> & {
  /**
   * @generated from field: sextante.proyectos.v1.MiProyectoItem proyecto = 1;
   */
  proyecto?: MiProyectoItem | undefined;

  /**
   * "verde" | "amarillo" | "rojo" — mismo calculo que usa la Plataforma.
   *
   * @generated from field: string semaforo = 2;
   */
  semaforo: string;

  /**
   * Desglose por tipo: CAPEX (Establecimiento) y OPEX (Sostenimiento).
   *
   * @generated from field: repeated sextante.proyectos.v1.MiProyectoDesglose desglose = 3;
   */
  desglose: MiProyectoDesglose[];

  /**
   * @generated from field: repeated sextante.proyectos.v1.MiProyectoLabor labores = 4;
   */
  labores: MiProyectoLabor[];
};

/**
 * Describes the message sextante.proyectos.v1.MiProyectoDetalleResponse.
 * Use `create(MiProyectoDetalleResponseSchema)` to create a new message.
 */
export const MiProyectoDetalleResponseSchema: GenMessage<MiProyectoDetalleResponse> = /*@__PURE__*/
  messageDesc(file_proyectos, 4);

/**
 * Presupuestado y ejecutado de un tipo de item.
 *
 * @generated from message sextante.proyectos.v1.MiProyectoDesglose
 */
export type MiProyectoDesglose = Message<"sextante.proyectos.v1.MiProyectoDesglose"> & {
  /**
   * CAPEX | OPEX
   *
   * @generated from field: string tipo = 1;
   */
  tipo: string;

  /**
   * @generated from field: int64 presupuestado = 2;
   */
  presupuestado: bigint;

  /**
   * @generated from field: int64 ejecutado = 3;
   */
  ejecutado: bigint;
};

/**
 * Describes the message sextante.proyectos.v1.MiProyectoDesglose.
 * Use `create(MiProyectoDesgloseSchema)` to create a new message.
 */
export const MiProyectoDesgloseSchema: GenMessage<MiProyectoDesglose> = /*@__PURE__*/
  messageDesc(file_proyectos, 5);

/**
 * Una "labor" es un item del proyecto, sin precios: el agricultor ve QUE se hace y como va,
 * no cuanto cuesta cada cosa.
 *
 * @generated from message sextante.proyectos.v1.MiProyectoLabor
 */
export type MiProyectoLabor = Message<"sextante.proyectos.v1.MiProyectoLabor"> & {
  /**
   * CAPEX | OPEX — agrupa en Establecimiento / Sostenimiento
   *
   * @generated from field: string tipo = 1;
   */
  tipo: string;

  /**
   * subseccion ("1.1 Estudios Preliminares")
   *
   * @generated from field: string sub = 2;
   */
  sub: string;

  /**
   * @generated from field: string nombre = 3;
   */
  nombre: string;

  /**
   * pendiente | en_ejecucion | completado — avance REAL que marca el técnico
   * (ProyectoItemModel.AvanceEstado), no derivado del gasto.
   *
   * @generated from field: string estado = 4;
   */
  estado: string;
};

/**
 * Describes the message sextante.proyectos.v1.MiProyectoLabor.
 * Use `create(MiProyectoLaborSchema)` to create a new message.
 */
export const MiProyectoLaborSchema: GenMessage<MiProyectoLabor> = /*@__PURE__*/
  messageDesc(file_proyectos, 6);

/**
 * Vista del AGRICULTOR sobre sus propios proyectos (mockup PM_C_Agricultor), en la app Cliente. Solo
 * lectura. Logica propia del servicio gRPC desde el 2026-10-03, con las mismas formulas de presupuesto
 * que Proyectos de Plataforma (sextante.plataforma.proyectos.v1), que tambien paso a gRPC ese dia.
 * 
 * Alcance deliberadamente recortado respecto al REST de admin: el agricultor no ve precios
 * unitarios, ni proveedores, ni el detalle de cada gasto, ni la desviacion por item. Solo lo
 * que la pantalla muestra: cabecera de la finca, estado financiero agregado y el listado de
 * labores con su estado de ejecucion.
 * 
 * SIN DELTA: no hay `ultima_sincronizacion` ni tombstones. Son pocos proyectos por agricultor
 * y el dato cambia cuando el tecnico registra gastos, asi que el cliente cachea por cooldown
 * corto, no por watermark (ver ProyectoMiListaGrpcService.ts).
 * 
 * Identidad: el cliente se resuelve de la sesion via IAccountService, NUNCA se recibe un cliente_id
 * por parametro — si no, cualquiera leeria los proyectos de otro.
 *
 * @generated from service sextante.proyectos.v1.ProyectosClienteService
 */
export const ProyectosClienteService: GenService<{
  /**
   * Proyectos del agricultor autenticado (alimenta el selector y la cabecera).
   *
   * @generated from rpc sextante.proyectos.v1.ProyectosClienteService.GetMisProyectos
   */
  getMisProyectos: {
    methodKind: "unary";
    input: typeof GetMisProyectosRequestSchema;
    output: typeof MisProyectosResponseSchema;
  },
  /**
   * Detalle de uno de SUS proyectos: estado financiero + labores. Si el id no es suyo
   * responde NOT_FOUND (no PERMISSION_DENIED, para no revelar que el id existe).
   *
   * @generated from rpc sextante.proyectos.v1.ProyectosClienteService.GetMiProyectoDetalle
   */
  getMiProyectoDetalle: {
    methodKind: "unary";
    input: typeof GetMiProyectoDetalleRequestSchema;
    output: typeof MiProyectoDetalleResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_proyectos, 0);

